var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11C11.4477 11 11 11.4477 11 12V28.6516C11 29.5059 12.0021 29.9668 12.6508 29.4108L15.7875 26.7222C16.3312 26.2562 17.0237 26 17.7398 26H24C24.5523 26 25 25.5523 25 25V20H27V25C27 26.6569 25.6569 28 24 28H17.7398C17.5011 28 17.2703 28.0854 17.0891 28.2407L13.9524 30.9293C12.0064 32.5973 9 31.2146 9 28.6516V12C9 10.3431 10.3431 9 12 9H24V11H12Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17H13V15H20V17Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21H13V19H20V21Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9276 9.14496C34.6547 9.97645 34.5701 11.24 33.7386 11.9671L27.2883 17.6076C26.8738 17.9701 26.3282 18.1456 25.7801 18.0928L22.3112 17.7588L22.6383 14.4243C22.688 13.9177 22.929 13.4491 23.3122 13.1141L29.7889 7.4504C30.6204 6.72329 31.8839 6.80791 32.611 7.6394L33.9276 9.14496ZM25.9718 16.102L32.422 10.4615L31.1055 8.95596L24.6288 14.6196L24.4973 15.9601L25.9718 16.102Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsIcon);
export default __webpack_public_path__ + "static/media/BlogsIcon.8360c278274e670e90fe787f6ad8fcc6.svg";
export { ForwardRef as ReactComponent };